(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Accordion functionality
    const faqItems = document.querySelectorAll('.faq-item');
    
    faqItems.forEach(item => {
      const question = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      
      question.addEventListener('click', () => {
        const isActive = item.classList.contains('active');
        
        // Close all items
        faqItems.forEach(i => {
          i.classList.remove('active');
          i.querySelector('.faq-answer').style.maxHeight = null;
        });
        
        // Open clicked item if it wasn't active
        if (!isActive) {
          item.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });

    // Category filter
    const categoryBtns = document.querySelectorAll('.faq-category-btn');
    const groupWrappers = document.querySelectorAll('.faq-group-wrapper');

    categoryBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const selectedCategory = btn.dataset.category;

        // Update active button
        categoryBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        // Filter FAQ groups by group_id
        groupWrappers.forEach(group => {
          const groupId = group.dataset.groupId;

          // Show all groups if "all" is selected, otherwise filter by group_id
          if (selectedCategory === 'all') {
            group.style.display = 'flex';
          } else if (groupId === selectedCategory) {
            group.style.display = 'flex';
          } else {
            group.style.display = 'none';
          }
        });
      });
    });

    // Search functionality
    const searchInput = document.getElementById('faq-search-input');
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase();

        // Search through all FAQ items
        faqItems.forEach(item => {
          const question = item.querySelector('.faq-question-text').textContent.toLowerCase();
          const answer = item.querySelector('.faq-answer-content').textContent.toLowerCase();

          if (question.includes(searchTerm) || answer.includes(searchTerm)) {
            item.style.display = 'block';
          } else {
            item.style.display = 'none';
          }
        });

        // Hide/show group wrappers based on visible items
        groupWrappers.forEach(group => {
          const visibleItems = group.querySelectorAll('.faq-item[style="display: block;"], .faq-item:not([style*="display: none"])');
          const hasVisibleItems = Array.from(group.querySelectorAll('.faq-item')).some(item => {
            return item.style.display !== 'none';
          });

          if (hasVisibleItems) {
            group.style.display = 'flex';
          } else {
            group.style.display = 'none';
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Mobile menu toggle functionality
  if (window.innerWidth < 989) {
    document.querySelectorAll('[data-footer-toggle]').forEach(button => {
      button.addEventListener('click', function() {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
      });
    });
  }

  document.querySelectorAll('.footer-credits').forEach(el => {
    if (el.innerHTML.includes('LANTERN SOL') && !el.innerHTML.includes('href')) {
      el.innerHTML = el.innerHTML.replace(
        'LANTERN SOL',
        '<a href="https://www.lanternsol.com/" target="_blank" rel="noopener" class="footer-credits__link">LANTERN SOL</a>'
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Lazy load menu images only when menu opens
  (function() {
    var imagesLoaded = false;
    function loadMenuImages() {
      if (imagesLoaded) return;
      imagesLoaded = true;
      document.querySelectorAll('.menu-lazy-image[data-src]').forEach(function(img) {
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      });
    }
    // Load on menu hover (desktop)
    document.querySelectorAll('.menu-list__link[aria-haspopup]').forEach(function(link) {
      link.addEventListener('mouseenter', loadMenuImages, { once: true });
      link.addEventListener('focus', loadMenuImages, { once: true });
    });
    // Load on menu drawer open (mobile) - listen for details toggle
    var menuDrawerDetails = document.getElementById('Details-menu-drawer-container');
    if (menuDrawerDetails) {
      menuDrawerDetails.addEventListener('toggle', function() {
        if (menuDrawerDetails.open) {
          loadMenuImages();
        }
      });
    }
    // Also listen for click on hamburger icon as fallback
    document.addEventListener('click', function(e) {
      if (e.target.closest('.header__icon--menu, .header-drawer-icon, [data-menu-drawer-toggle]')) {
        loadMenuImages();
      }
    });
  })();

  // Header menu animation state observer - must run immediately after header
  (function() {
    var header = document.getElementById('header-component');
    if (!header) return;

    var pendingAnimatingClass = null;

    // Add class on menu item pointerleave, but with a small delay to check if mouse moved to another menu item
    var menuItems = header.querySelectorAll('.menu-list__list-item');
    menuItems.forEach(function(item) {
      item.addEventListener('pointerleave', function(e) {
        var link = item.querySelector('.menu-list__link[aria-haspopup]');
        if (link && (link.getAttribute('aria-expanded') === 'true' || link.hasAttribute('data-animating'))) {
          // Set a very short timeout to check if mouse is still in header
          pendingAnimatingClass = setTimeout(function() {
            // Only add class if mouse is NOT over header anymore
            if (!header.matches(':hover')) {
              header.classList.add('header--menu-animating');
            }
          }, 10);
        }
      });

      item.addEventListener('pointerenter', function() {
        // Cancel pending class addition if mouse entered another menu item
        if (pendingAnimatingClass) {
          clearTimeout(pendingAnimatingClass);
          pendingAnimatingClass = null;
        }
      });
    });

    // Backup: add class when mouse leaves header entirely
    header.addEventListener('pointerleave', function() {
      var expandedLink = header.querySelector('.menu-list__link[aria-expanded="true"]');
      var animatingLink = header.querySelector('.menu-list__link[data-animating]');
      if (expandedLink || animatingLink) {
        header.classList.add('header--menu-animating');
      }
    });

    // Remove class when mouse enters header again
    header.addEventListener('pointerenter', function() {
      if (pendingAnimatingClass) {
        clearTimeout(pendingAnimatingClass);
        pendingAnimatingClass = null;
      }
      header.classList.remove('header--menu-animating');
    });

    // Observer to remove class when animation ends
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-animating') {
          var target = mutation.target;
          if (!target.hasAttribute('data-animating')) {
            setTimeout(function() {
              if (!header.querySelector('.menu-list__link[data-animating]') && !header.matches(':hover')) {
                header.classList.remove('header--menu-animating');
              }
            }, 50);
          }
        }
      });
    });

    observer.observe(header, {
      attributes: true,
      attributeFilter: ['data-animating'],
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let gallerySwiper = null;
    const mobileBreakpoint = 768;

    function updateProgressBar(swiper) {
      const progressFill = document.querySelector('.swiper-progress-fill');
      if (!progressFill || !swiper || !swiper.slides) return;
      const progress = ((swiper.activeIndex + 1) / swiper.slides.length) * 100;
      progressFill.style.width = progress + '%';
    }

    function initGallerySwiper() {
      // Already initialized
      if (gallerySwiper) return;

      // Wait for Swiper to be available (loaded asynchronously)
      if (typeof Swiper === 'undefined') {
        setTimeout(initGallerySwiper, 100);
        return;
      }

      const swiperContainer = document.querySelector('.gallerySwiper');
      if (!swiperContainer) return;

      gallerySwiper = new Swiper('.gallerySwiper', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: false,
        slideToClickedSlide: true,
        on: {
          init: function() {
            updateProgressBar(this);
          },
          slideChange: function() {
            updateProgressBar(this);
          },
          progress: function() {
            updateProgressBar(this);
          }
        }
      });
    }

    function destroyGallerySwiper() {
      if (gallerySwiper) {
        gallerySwiper.destroy(true, true);
        gallerySwiper = null;
      }
    }

    function handleResize() {
      const isMobile = window.innerWidth <= mobileBreakpoint;

      if (isMobile && !gallerySwiper) {
        // Switching to mobile - initialize swiper
        initGallerySwiper();
      } else if (!isMobile && gallerySwiper) {
        // Switching to desktop - destroy swiper
        destroyGallerySwiper();
      } else if (isMobile && gallerySwiper) {
        // Still mobile - update swiper
        gallerySwiper.update();
        updateProgressBar(gallerySwiper);
      }
    }

    // Initial check
    handleResize();

    // Listen for resize with debounce
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls-hero-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.ls-hero-carousel-section');
  if (!section) return;

  const track = section.querySelector('.ls-hero-track');
  const slides = section.querySelectorAll('.ls-hero-slide');
  const imageSlides = section.querySelectorAll('.ls-hero-image-slide');
  const dots = section.querySelectorAll('.ls-carousel-dot');
  const prevBtn = section.querySelector('.ls-carousel-prev');
  const nextBtn = section.querySelector('.ls-carousel-next');

  let currentSlide = 0;
  const totalSlides = slides.length;

  function updateCarousel() {
    // Update content slides with position and visibility
    slides.forEach((slide, index) => {
      if (index === currentSlide) {
        slide.style.opacity = '1';
        slide.style.visibility = 'visible';
        slide.style.position = 'relative';
      } else {
        slide.style.opacity = '0';
        slide.style.visibility = 'hidden';
        slide.style.position = 'absolute';
      }
    });

    // Update image slides
    imageSlides.forEach((slide, index) => {
      slide.classList.toggle('active', index === currentSlide);
    });

    // Update dots
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentSlide);
    });
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % totalSlides;
    updateCarousel();
  }

  function prevSlide() {
    currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
    updateCarousel();
  }

  function goToSlide(index) {
    currentSlide = index;
    updateCarousel();
  }

  // Event listeners
  if (nextBtn) nextBtn.addEventListener('click', nextSlide);
  if (prevBtn) prevBtn.addEventListener('click', prevSlide);

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => goToSlide(index));
  });

  // Auto-advance (optional)
  // setInterval(nextSlide, 5000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
